import { Button, Table } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { z } from "zod";
import { GetRequest, PostRequest } from "../../../Utils/hooks/ApiHandler";
import { useEffect, useState } from "react";
import useLocalStorageState from "use-local-storage-state";
import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "sonner";
import { BsArrowLeft } from "react-icons/bs";

const prefixItemSchema = z.object({
  id: z.string(),
  prefix: z.string().min(1, "Please enter prefix"),
  module_name: z.string(),
  incremental_number: z.string().min(1, "Please enter start number"),
});

const prefixSchema = z.object({
  modules: z.array(prefixItemSchema),
});

const Prefix = () => {
  const [loading, setLoading] = useState(false);
  const [prefixData, setPrefixData] = useState([]);

  const [customer, setCustomer] = useLocalStorageState("customer");
  const navigate = useNavigate();
  //button state to validate
  const [buttonState, setButtonState] = useState(false);

  const customerId = customer?.customer_details?.customer_id;
  const userLoginId = customer?.customer_details?.id;
  const token = customer?.token?.authorization;
  const rf = customer?.token?.authentication;

  const headers = {
    authentication: rf,
    Authorization: token,
  };
  const extras = { customer, setCustomer, rf, navigate };

  const {
    handleSubmit,
    reset,
    control,
    setError,
    clearErrors,
    watch,
    formState: { errors, isValid, isSubmitting },
  } = useForm({
    resolver: zodResolver(prefixSchema),
    defaultValues: { modules: [] },
    mode: "onChange",
  });
  const watchModules = watch("modules");
  const hasManualErrors = Object.keys(errors).length > 0;

  //single function for validate both prefix and incremnetal number are unique or not
  const validatePrefixSeries = async (index, prefix, number, moduleName) => {
    try {
      if (!prefix && !number) return;

      const res = await GetRequest(
        `/common/VerifyPrefixSeries/${customerId}/${moduleName}/${prefix || ""
        }/${number || ""}`,
        { headers },
        { extras }
      );

      if (res?.status === "success") {
        setError(`modules.${index}.incremental_number`, {
          type: "manual",
          message: res.message || "This series of combination already exists",
        });
      } else {
        clearErrors(`modules.${index}.incremental_number`);
      }
    } catch (err) {
      console.error("Validation API error", err);
    }
  };

  const fetchPrefix = async () => {
    const res = await GetRequest(
      `preference/fetchPrefixes/${customerId}`,
      { headers },
      { extras }
    );
    if (res?.status === "success") {
      setPrefixData(res.data);

      reset({
        modules: res.data.map((item) => ({
          id: item.id,
          prefix: item.prefix,
          incremental_number: item.incremental_number,
          module_name: item.module_name,
        })),
      });
    }
  };

  useEffect(() => {
    fetchPrefix();
  }, []);

  const updatePrefixes = async (data) => {
    setLoading(true);
    const payload = {
      customer_id: customerId,
      prefix_items: data.modules.map((m) => ({
        prefix_id: m.id,
        module_name: m.module_name,
        prefix: m.prefix,
        incremental_number: m.incremental_number,
      })),
      user_login_id: userLoginId,
    };

    const res = await PostRequest(
      `/preference/createPrefix/`,
      payload,
      false,
      { headers },
      { extras }
    );
    if (res.status !== "success") {
      setLoading(false);
      alert("something went wrong");
    }

    if (res?.status === "success") {
      fetchPrefix();
      toast.success(res.message || "Prefix updated successfully");
      setLoading(false);
    }
  };

  return (
    <div className="p-4 position-relative">
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex gap-2 mt-1 mb-1 pb-0 align-items-center ">
          <div style={{ paddingRight: "20px" }}>
            <h5 className="fw-semibold mb-1">Prefix</h5>
            <p className="text-muted small ">
              Set prefixes and starting numbers for different records. Each new entry will be auto-created using the defined sequence (e.g., CT-112).
            </p>
          </div>
        </div>
        <div>
          <Button
            className="btn btn-default-outline ml-100%"
            onClick={() => navigate(-1)}
            style={{ width: "max-content" }}
          >
            <BsArrowLeft className="me-1" /> Back
          </Button>
        </div>
        {/* <button className="btn btn-primary"
      onClick={()=>navigate(-1)}>
        <i className="fa fa-arrow-left" aria-hidden="true" 
        // style={{fontSize:"12px"}}
        ></i> 
        Back</button> */}
      </div>

      <hr />

      <form onSubmit={handleSubmit(updatePrefixes)}>
        <Table hover>
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Name</th>
              <th style={{ width: "160px" }}>
                Prefix <span className="text-danger">*</span>
              </th>
              <th style={{ width: "100px" }}></th>
              <th style={{ width: "160px" }}>
                Start Number<span className="text-danger">*</span>
              </th>
              <th style={{ width: "350px" }}></th>
            </tr>
          </thead>
          <tbody>
            {prefixData?.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td className="text-capitalize">{item.module_name}</td>
                {/* Hidden field to keep module_name in payload */}
                <Controller
                  name={`modules.${index}.module_name`}
                  control={control}
                  defaultValue={item.module_name}
                  render={({ field }) => <input type="hidden" {...field} />}
                />
                <td>
                  <Controller
                    name={`modules.${index}.prefix`}
                    control={control}
                    render={({ field }) => (
                      <input
                        {...field}
                        type="text"
                        className="form-control"
                        placeholder="Enter Prefix"
                        onChange={(e) => {
                          field.onChange(e);
                          const value = e.target.value;
                          const currentNumber =
                            watchModules?.[index]?.incremental_number;
                          validatePrefixSeries(
                            index,
                            value,
                            currentNumber,
                            item.module_name
                          );
                        }}
                      />
                    )}
                  />

                  {errors?.modules?.[index]?.prefix && (
                    <p className="text-danger small">
                      {errors.modules[index].prefix.message}
                    </p>
                  )}
                </td>
                <td className="text-center">-</td>
                <td>
                  <Controller
                    name={`modules.${index}.incremental_number`}
                    control={control}
                    render={({ field }) => (
                      <input
                        {...field}
                        type="text"
                        className="form-control"
                        placeholder="Enter Number"
                        onChange={(e) => {
                          field.onChange(e);
                          const value = e.target.value;
                          const currentPrefix = watchModules?.[index]?.prefix;
                          validatePrefixSeries(
                            index,
                            currentPrefix,
                            value,
                            item.module_name
                          );
                        }}
                      />
                    )}
                  />

                  {errors?.modules?.[index]?.incremental_number && (
                    <p className="text-danger small">
                      {errors.modules[index].incremental_number.message}
                    </p>
                  )}
                </td>
                <td></td>
              </tr>
            ))}
          </tbody>
        </Table>
        <button
          type="submit"
          className="btn btn-default float-end mb-4 mt-1 px-4"
          disabled={hasManualErrors || isSubmitting}
        >
          {loading && (
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          )}
          {loading ? "Saving..." : "Save"}
        </button>
      </form>
    </div>
  );
};

export default Prefix;

//  {prefixData.map((item, index) => (
//         <div key={item.id} className="mb-3 border p-3 rounded">
//           <h6>{item.module_name}</h6>

{
  /* Prefix Field */
}
{
  /* <Controller
            name={`modules.${index}.prefix`}
            control={control}
            render={({ field }) => (
              <input
                {...field}
                type="text"
                className="form-control mb-2"
                placeholder="Enter Prefix"
              />
            )}
          /> */
}

{
  /* Incremental Number Field */
}
{
  /* <Controller
            name={`modules.${index}.incremental_number`}
            control={control}
            render={({ field }) => (
              <input
                {...field}
                type="text"
                className="form-control"
                placeholder="Enter Number"
              />
            )}
          /> */
}

{
  /* Hidden ID field */
}
{
  /* <Controller
            name={`modules.${index}.id`}
            control={control}
            render={({ field }) => <input 
            {...field} type="hidden" />}
          />
        </div>
      ))} */
}
